import overflow from '@/components/text/overflow'

const baseClass = 'entity'

function renderValue(h, value) {
  return h(
    overflow,
    {
      props: {
        value
      }
    }
  )
}
function renderCell(h, value) {
  return h(
    'td',
    {
      class: `${baseClass}__cell`
    },
    [ renderValue.call(this, h, value) ]
  )
}
function renderRow(h, row) {
  return h(
    'tr',
    {
      class: `${baseClass}__row`
    },
    [
      renderCell.call(this, h, row.title),
      renderCell.call(this, h, row.value)
    ]
  )
}
function renderRows(h) {
  return this.rows.map(row => {
    return renderRow.call(this, h, row)
  })
}
function renderBody(h) {
  return h(
    'tbody',
    {
      class: `${baseClass}__body`
    },
    [ renderRows.call(this, h) ]
  )
}

export default function(h) {
  return h(
    'table',
    {
      class: baseClass
    },
    [ renderBody.call(this, h) ]
  )
}
